export const DashboardReportingSections = [
    {
        Id: 1,
        CheckboxIdentifier: 'headcountPerRaceAndOccupationalLevel',
        Selected: false,
        Name: 'Headcount per Race and Occupational Level Dashboard',
        Date: {
            Type: "InputDate",
            LabelText: "View employees as at",
        }
    },
    {
        Id: 2,
        CheckboxIdentifier: 'movements',
        Selected: false,
        Name: 'Movements (Recruitments, Promotions, Terminations) Dashboard',
        Date: {
            Type: "EndDate",
            LabelText: "For the period ending on",
        }
    },
    {
        Id: 3,
        CheckboxIdentifier: 'incomeDifferentials',
        Selected: false,
        Name: 'Income Differentials Dashboard',
        Date: {
            Type: "ReportingDate",
            LabelText: "For the measurement period",
        }
    },
    {
         Id: 4,
         CheckboxIdentifier: 'workforceProfile',
         Selected: false,
         Name: 'Workforce Profile (EEA2) (All Employees, Disabled Employees) Table',
         Date: {
             Type: "InputDate",
             LabelText: "Workforce profile snapshot date",
         }
    }
];
  